import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useUserAccountProfile } from 'frontastic/hooks/useUserAccountProfile';

/** Component to handle client-side country field updates */
const CountryAutoFill = ({
  shouldAutoFillPii,
}: {
  shouldAutoFillPii: boolean;
}) => {
  const { setValue } = useFormContext();
  const userAccountProfile = useUserAccountProfile();
  const [isClient, setIsClient] = useState(false);

  // Ensure this only runs on the client side
  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    // Only update country on client side after hydration
    if (isClient && shouldAutoFillPii && userAccountProfile?.country) {
      setValue('country', userAccountProfile.country, {
        shouldDirty: true,
        shouldTouch: true,
        shouldValidate: true,
      });
    }
  }, [isClient, shouldAutoFillPii, userAccountProfile, setValue]);

  return null;
};

export default CountryAutoFill;
